import React from 'react';
import usePermission from '../hooks/usePermission';

const ProtectedRoute = ({children, permissionName}) => {
    const userPermission = usePermission(permissionName);
    return userPermission ? children : <h1>Page not found (404)</h1>;
};

export default ProtectedRoute;
